export default "__VITE_ASSET__1d48e519__"